<template>
  <div class="bg">
    <el-row :gutter="20">
      <el-col :span="24" class="btn">
        <div style="text-align: right">
          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            :disabled="one"
            @click="handleFirst"
            >一级揭盲</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            size="small"
            :disabled="two"
            @click="handleTwo"
            >二级揭盲</el-button
          >
        </div>
      </el-col>
    </el-row>
    <div class="container-table">
      <el-table
        stripe
        size="mini"
        :data="listData"
        style="width: 100%"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column prop="create_user_name" label="操作者" width="200" />
        <el-table-column prop="name" label="揭盲级数" width="160">
          <template slot-scope="scope">
            <el-tooltip placement="bottom" effect="light">
              <div slot="content" style="color: #85a5ff">
                <el-link
                  type="primary"
                  :underline="false"
                  class="edit"
                  @click="handleList(scope.row)"
                  >查看</el-link
                >
                <el-link
                  type="primary"
                  :underline="false"
                  class="edit"
                  @click="handleDownOne(scope.row)"
                  >下载</el-link
                >
              </div>
              <el-button type="text" size="mini" style="font-size: 12px">{{
                scope.row.name
              }}</el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作时间" prop="create_time" />
        <el-table-column label="操作原因" prop="reason" />
      </el-table>
    </div>
    <!--分页-->
    <!--一级揭盲-->
    <el-dialog
      center
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleFirst"
      width="40%"
    >
      <div slot="title" class="title">一级揭盲</div>
      <div class="proInfo">
        <el-row
          style="
            text-align: center;
            margin-bottom: 10px;
            color: #595959;
            font-weight: 500;
          "
          >是否确认执行一级揭盲？</el-row
        >
        <el-row>
          <el-col :span="4">揭盲原因：</el-col>
          <el-col :span="18">
            <el-input
              v-model="reason"
              size="mini"
              type="textarea"
              placeholder="请输入内容"
              show-word-limit
            />
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          size="mini"
          type="primary"
          @click="handleOne"
          >确 定</el-button
        >
        <el-button size="mini" @click="handleCancelOne">取 消</el-button>
      </span>
    </el-dialog>
    <!--二级揭盲-->
    <el-dialog
      center
      :visible.sync="dialogVisibleTwo"
      :close-on-click-modal="false"
      width="40%"
    >
      <div slot="title" class="title">二级揭盲</div>
      <div class="proInfo">
        <el-row
          style="
            text-align: center;
            margin-bottom: 10px;
            color: #595959;
            font-weight: 500;
          "
          >是否确认执行二级揭盲？</el-row
        >
        <el-row>
          <el-col :span="4">揭盲原因：</el-col>
          <el-col :span="18">
            <el-input
              v-model="reasonTwo"
              size="mini"
              type="textarea"
              placeholder="请输入内容"
              show-word-limit
            />
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          size="mini"
          type="primary"
          @click="handleTwos"
          >确 定</el-button
        >
        <el-button size="mini" @click="handleCancelTwo">取 消</el-button>
      </span>
    </el-dialog>
    <!--一级级盲列表查看-->
    <el-dialog
      center
      :visible.sync="dialogVisibleFirstSee"
      :close-on-click-modal="false"
      width="60%"
    >
      <div slot="title" class="title">一级盲底</div>
      <div class="proInfo">
        <el-table :data="oneData" size="mini" border style="width: 100%">
          <el-table-column prop="random_code_combination" label="随机号" />
          <el-table-column prop="group_code" label="第一次随机试验组别" />
        </el-table>
        <div class="pages">
          <el-pagination
            samll
            background
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handleOneClose"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!--二级级盲列表查看-->
    <el-dialog
      center
      :visible.sync="dialogVisibleTwoSee"
      :close-on-click-modal="false"
      width="60%"
    >
      <div slot="title" class="title">二级盲底</div>
      <div class="proInfo">
        <el-table :data="twoData" size="mini" border style="width: 100%">
          <el-table-column prop="random_code_combination" label="随机号" />
          <el-table-column
            prop="group_code"
            label="第一次随机试验组别"
            width="180"
          />
          <el-table-column
            prop="group_name"
            label="第一次随机试验组名"
            width="180"
          />
        </el-table>
        <div class="pages">
          <el-pagination
            samll
            background
            :current-page="currentPage1"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize1"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total1"
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handleTwoClose"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { one, onePage, two, twoPage, list } from "@/api/subjects";
import { getProjectId } from "@/utils/auth";

export default {
  name: "Unblinding",
  data() {
    return {
      dialogVisibleFirst: false,
      proId: "",
      one: false,
      reason: "",
      currentPage: 1,
      pageSize: 10,
      total: null,
      currentPage1: 1,
      pageSize1: 10,
      total1: null,
      two: false,
      reasonTwo: "",
      dialogVisibleTwo: false,
      listData: [],
      dialogVisibleFirstSee: false,
      oneData: [],
      dialogVisibleTwoSee: false,
      twoData: [],
      userDetail: JSON.parse(sessionStorage.getItem("iwrs_user")),
    };
  },
  created() {
    this.proId = getProjectId();
    this.getList();
  },
  methods: {
    handleList(row) {
      console.log(row);
      if (row.name === "一级揭盲") {
        this.dialogVisibleFirstSee = true;
        this.onePage();
      } else {
        this.dialogVisibleTwoSee = true;
        this.twoPage();
        console.log("二级揭盲");
      }
    },
    handleDownOne(row) {
      if (row.name === "一级揭盲") {
        const baseUrl =
          process.env.VUE_APP_BASE_API +
          "/v1.0/iwrs/unblind/export1?project_id=" +
          this.proId +
          "&user_id=" +
          this.userDetail.id;
        window.open(baseUrl, "_self");
      } else {
        const baseUrl =
          process.env.VUE_APP_BASE_API +
          "/v1.0/iwrs/unblind/export2?project_id=" +
          this.proId +
          "&user_id=" +
          this.userDetail.id;
        window.open(baseUrl, "_self");
      }
    },
    handleTwoClose() {
      this.dialogVisibleTwoSee = false;
    },
    handleOneClose() {
      this.dialogVisibleFirstSee = false;
    },
    getList() {
      list({ project_id: this.proId })
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.length > 0) {
              this.listData = res.data;
              res.data.map((item) => {
                if (item.name === "一级揭盲") {
                  this.one = true;
                } else if (item.name === "二级揭盲") {
                  this.two = true;
                }
              });
            } else {
              this.listData = [];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    handleFirst() {
      this.dialogVisibleFirst = true;
    },
    handleTwo() {
      this.dialogVisibleTwo = true;
    },
    handleCancelOne() {
      this.reason = "";
      this.dialogVisibleFirst = false;
      this.getList();
    },
    handleOne() {
      const params = {
        project_id: this.proId,
        reason: this.reason,
      };
      console.log(params);
      one(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.one = true;
            this.handleCancelOne();
            this.$message({
              message: res.msg,
              type: "success",
            });
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    handleCancelTwo() {
      this.reasonTwo = "";
      this.dialogVisibleTwo = false;
      this.getList();
    },
    handleTwos() {
      const params = {
        project_id: this.proId,
        reason: this.reasonTwo,
      };
      two(params)
        .then((res) => {
          if (res && res.code === 0) {
            this.handleCancelTwo();
            this.two = true;
            this.$message({
              message: res.msg,
              type: "success",
            });
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.onePage();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onePage();
    },
    // 每页条数
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.currentPage1 = 1;
      this.twoPage();
    },
    // 当前页数
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.twoPage();
    },
    // 修改表头颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // 改表头颜色
      if (rowIndex === 0) {
        return "background-color: #D6E4FF;color: #595959;";
      }
    },
    onePage() {
      const params = {
        project_id: this.proId,
        page: this.currentPage - 1,
        page_size: this.pageSize,
      };
      onePage(params)
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.length > 0) {
              this.oneData = res.data;
              this.total = res.total;
            } else {
              this.oneData = [];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
    twoPage() {
      const params = {
        project_id: this.proId,
        page: this.currentPage1 - 1,
        page_size: this.pageSize1,
      };
      twoPage(params)
        .then((res) => {
          if (res && res.code === 0) {
            if (res.data && res.data.length > 0) {
              this.twoData = res.data;
              this.total1 = res.total;
            } else {
              this.twoData = [];
            }
          } else {
            this.$message(res.msg);
          }
        })
        .catch((res) => {
          console.log(res.msg);
        });
    },
  },
};
</script>

<style scoped>
.bg {
  /*background-image: url(../../assets/avatar/no.png);*/
  width: 100%;
  height: 720px;
  background-repeat: no-repeat;
  background-position-x: center;
  margin: 0 auto;
  /*border: 1px solid red;*/
  background-size: cover;
}
.btn {
  text-align: right;
}
.container-table {
  margin-top: 20px;
}
.title {
  padding: 15px 0;
  background-color: #d6e4ff;
  color: #595959;
  font-weight: 500;
  font-size: 16px;
}
.proInfo {
  background-color: #f0f5ff;
  padding: 20px 30px;
}
.row {
  margin: 20px 0;
  font-size: 14px;
  color: #595959;
}
.left {
  line-height: 26px;
  text-align: right;
}
.pages {
  margin-top: 30px;
  text-align: right;
}
.edit {
  font-size: 12px;
  margin-right: 10px;
}
</style>
<style>
.el-dialog__header {
  padding: 0px;
}
.container-table {
  border: 1px solid #e5eeff;
}
.el-tooltip__popper.is-light {
  border: none;
  background: #ffffff;
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    -1px -1px 12px 0px rgba(0, 0, 0, 0.12);
}
.popper__arrow {
  border: none !important;
}

.btn-custom-cancel {
  float: right;
  margin-left: 10px;
}
.el-table__column-filter-trigger i {
  color: #000;
  font-size: 14px;
}
.diaBg {
  background-color: #f0f5ff;
  padding: 20px;
}
</style>
